import axios from 'axios';

// Create an Axios instance
const userAxios = axios.create();

userAxios.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const setupAxiosInterceptors = (handleInvalidToken) => {
  userAxios.interceptors.response.use(
    response => response,
    error => {
      if (error.response && error.response.status === 401) {
        const location = window.location.pathname;
        const unprotectedRoutes = ['/login', '/reset', '/forgotpassword'];
        if (!unprotectedRoutes.includes(location)) {
          handleInvalidToken();
        }
      }
      return Promise.reject(error);
    }
  );
};

export { userAxios, setupAxiosInterceptors };
